function asAttributes(object) {
  return Object.entries(object).map(([key, value]) => ({
    key,
    value: {
      stringValue: String(value)
    }
  }));
}

export { asAttributes };
